import { calmTokens as t } from '../../shared/tokens';
import { MONTHS_FR, MONTHS_FR_SHORT } from '../../shared/locale';
import { IconChevLeft, IconChevRight } from '../../shared/icons';

const arrowStyle = {
  width: 'var(--mp-btn, 32px)',
  height: 'var(--mp-btn, 32px)',
  borderRadius: 999,
  background: 'transparent',
  border: 'none',
  color: t.textDim,
  cursor: 'pointer',
  display: 'grid',
  placeItems: 'center',
  padding: 0,
  flexShrink: 0,
  touchAction: 'manipulation',
};

export default function CalmMonthPicker({ month, year, onChange }) {
  const goPrev = () => {
    if (month === 0) onChange(11, year - 1);
    else onChange(month - 1, year);
  };
  const goNext = () => {
    if (month === 11) onChange(0, year + 1);
    else onChange(month + 1, year);
  };

  return (
    <div
      className="calm-month-picker"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: t.surface,
        border: `1px solid ${t.borderS}`,
        borderRadius: 999,
        padding: 'var(--mp-pad, 4px)',
        gap: 2,
        fontFamily: t.fontUi,
      }}
    >
      <button
        type="button"
        onClick={goPrev}
        title="Mois précédent"
        aria-label="Mois précédent"
        style={arrowStyle}
      >
        <IconChevLeft size={15} />
      </button>

      <div
        style={{
          padding: 'var(--mp-label-pad, 6px 14px)',
          fontSize: 'var(--mp-font, 13px)',
          fontWeight: 500,
          color: t.text,
          letterSpacing: -0.1,
          whiteSpace: 'nowrap',
        }}
      >
        {/* Bascule long / court en CSS pur (voir `.calm-mp-long` et
            `.calm-mp-short` dans index.css) : pas de matchMedia en JS, donc
            pas de saut au redimensionnement ni de rendu à réconcilier. */}
        <span className="calm-mp-long">
          {MONTHS_FR[month]} {year}
        </span>
        <span className="calm-mp-short">
          {MONTHS_FR_SHORT[month]} {year}
        </span>
      </div>

      <button
        type="button"
        onClick={goNext}
        title="Mois suivant"
        aria-label="Mois suivant"
        style={arrowStyle}
      >
        <IconChevRight size={15} />
      </button>
    </div>
  );
}
